module.exports = __webpack_public_path__ + "static/media/Lars Jensen.a04789ab.jpg";